module.exports = __webpack_public_path__ + "static/media/contrast-light-logo.cd0edeea.png";